export default "__VITE_ASSET__CnttIy1r__"